<script>
    import QuickInput from 'views/components/quickInput/QuickInput.svelte'
    import { parseGapInputAsNumber } from 'views/components/taskGroups/tasks/template41/GapTextUtil'

    let {
        value = $bindable(''),
    } = $props()

    let quickInput

    function onInput(rawValue) {
        // Strip disallowed characters as the user types/pastes, since QuickInput
        // itself doesn't restrict which characters can be entered.
        const filtered = rawValue.replace(/[^0-9,.\- ]/g, '')
        if (filtered !== rawValue) {
            quickInput.setValue(filtered)
        }

        // Add a red border when the input is not a valid number
        if (filtered.length && parseGapInputAsNumber(filtered).error) {
            quickInput.setInvalidState()
        }

        value = filtered
    }
</script>

<QuickInput
    bind:this={quickInput}
    {value}
    inputMode="decimal"
    noAutoCapitalize={true}
    noAutoCorrect={true}
    displayInline={true}
    inputCallback={onInput}
></QuickInput>
